/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import howLongAgo from 'lib/howLongAgo';

let ReleaseInfo = ({ app }) => {
  if (!app || !app._server_latest_build) {
    return '';
  }

  return [
    'Latest deploy: ',
    app._server_latest_version ? app._server_latest_version.commit.substring(0, 10) : '',
    ' \u2022 ',
    howLongAgo(app._server_latest_build),
    // ' \u2022 SDK Version: ',
    // release.parseVersion
  ].join('');
};

export default ReleaseInfo;
